import { styled } from '../setup'
import { borders, typography } from '../theme'

// Profile button colors (see CLAUDE-UI.md)
const purple = {
  base: '#5A3E6B',
  hover: '#6A4A7D',
  active: '#4A3259',
}

const AvatarContainer = styled('div')<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background: ${purple.base};
  border: ${borders.widthMedium} solid ${purple.active};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: ${typography.fontWeightBold};
  font-size: ${(props) => Math.floor(props.size * 0.38)}px;
  text-transform: uppercase;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background 0.15s;

  &:hover {
    background: ${purple.hover};
  }

  &:active {
    background: ${purple.active};
  }
`

interface AvatarProps {
  name: string
  size?: number
}

export function Avatar({ name, size = 48 }: AvatarProps) {
  const initials = name.slice(0, 2)

  return <AvatarContainer size={size}>{initials}</AvatarContainer>
}
